import { Component } from '@angular/core';
import { TabsMediaCardsSectionComponent } from '../tabs-media-cards-section/tabs-media-cards-section.component';

@Component({
  selector: 'ft-tabs-media-cards-index',
  templateUrl: './tabs-media-cards-index.component.html',
})
export class TabsMediaCardsIndexComponent extends TabsMediaCardsSectionComponent {}
